import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { throwError } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';
import { environment } from '../environments/environment';

export let ACCESS_KEYS: string = 'accessTachomatKeys';

@Injectable()
export class AppConfig {
	public errorPage: string = `
<!DOCTYPE html>
<html>
<body>
<h1>Starting application error!</h1>
<p>The application can not be launched. The remote configuration file is missing.</p>
</body>
</html>`;

	public config: any = {};

	constructor( private http: HttpClient ) { }

	/**
	 * Get api endpoint address. use: appconfig.api('add_drivers'), it will return eg: http://172.20.49.34:8080/v1/drivers
	 * @param key - name of endpoint key
	 */
	public api( key: string ): string {
		return this.config.api && this.config.api.hasOwnProperty( key )
			? this.config.api[ key ]
			: null;
	}

	/**
	 * Use to get the allData found in the configuration
	 */
	public getConfig( key: string | null ): any {
		const args: string[] = key !== null ? key.split( '.' ) : [];
		let obj: any = this.config;
		args.forEach( arg => {
			obj = obj[ arg ];
		} );

		return obj;
	}

	public hasProperty( key: string | null ): boolean {
		const args: string[] = key !== null ? key.split( '.' ) : [];
		let obj: any = this.config;
		for (const arg of args) {
			if(!(arg in obj)) {
				return false
			}
			obj = obj [arg];
		}
		return true;
	}

	/**
	 * Get current page language
	 */
	public getDefaultLang(): string {
		return this.config && this.config.i18n
			? this.config.i18n.defaultLang
			: 'en';
	}

	public getOSLang(): string {
		return navigator.language.substr( 0, 2 );
	}

	/**
	 * Get current page language
	 */
	public getCurrentLang(): string {
		return this.config && this.config.currentLang
			? this.config.currentLang
			: this.config.i18n
				? this.config.i18n.defaultLang
				: null;
	}

	/**
	 * Setting language version of the page
	 * @param lang - current language version
	 */
	public setCurrentLanguage( lang: string ): void {
		if ( this.config ) {
			this.config.currentLang = lang;
		}
	}

	/**
	 * Get remote config address file
	 */
	public getConfigLocation(): string {
		const location: string = environment.hasOwnProperty( 'configuration' )
			? environment.configuration
			: 'config/config.json';

		return location;
	}

	/**
	 * This method loads configuration from remote location
	 */
	public load(): Promise<any> {
		const remoteConfig: string = this.getConfigLocation();

		return new Promise(
			( resolve, reject ): void => {
				this.http
					.get( remoteConfig )
					.pipe(
						map( ( resp: any ): string => resp[ 'configLocation' ]
							.replace( '${releaseTag}', resp[ 'releaseTag' ] ? resp[ 'releaseTag' ] : 'develop' ) as string ),
						switchMap( ( conf: string ): any => this.http.get( conf ) ),
						catchError(
							( error: any ): any => {
								console.error(
									`Configuration file ${remoteConfig} could not be read`,
									error
								);
								document.write( this.errorPage );
								return throwError(
									'Remote configuration read error!'
								);
							}
						)
					)
					.subscribe( config => {
						this.config = config;
						resolve( true );
					} );
			}
		);
	}
}
